import { withStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { useSelector, useDispatch } from "react-redux";
import { changeSelectedEmail } from "../store/quotes";
import { useEffect, useState } from "react";

const SelectEmail = (props) => {
  const { code, emails } = props;
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();
  const selectedemail = useSelector((state) => {
    let selectedemail =
      state.entities.quotes.insurerdetails[code]["selectedemail"];

    return selectedemail;
  });

  const handleChange = (event) => {
    let selectedemail = event.target.value;

    dispatch(changeSelectedEmail({ code, selectedemail }));
  };

  const StyledMenuItem = withStyles((theme) => ({
    root: {
      fontSize: "1.9vmin",
      color: "grey",
      fontFamily: "GibsonRegular",
    },
  }))(MenuItem);

  const StyledSelect = withStyles((theme) => ({
    root: {
      fontSize: "1.7vmin",
      color: "grey",
      fontFamily: "GibsonRegular",
    },
  }))(Select);

  useEffect(() => {
    const timeout = setTimeout(() => setShow(true), 25);
    return () => clearTimeout(timeout);
  });
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        height: "100%",
      }}
    >
      {show ? (
        <StyledSelect
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={selectedemail}
          fullWidth
          onChange={handleChange}
        >
          {emails &&
            emails.map((item, index) => (
              <StyledMenuItem key={code + "" + index} value={item.email}>
                <b>{item.email}</b> &nbsp;{item.description}{" "}
              </StyledMenuItem>
            ))}
        </StyledSelect>
      ) : (
        <div
          style={{
            width: "100%",
            fontFamily: "GibsonRegular",
            color: "grey",
            alignContent: "center",
            justifyContent: "center",
            display: "flex",
          }}
        >
          Getting all emails..
        </div>
      )}
    </div>
  );
};

export default SelectEmail;
